import { PropsWithChildren } from "react";

import SplashScreen from "@/components/SplashScreen";
import { useIsI18nLoading } from "@/i18n";

export const I18nSplashScreenProvider = ({ children }: PropsWithChildren) => {
  const isLoading = useIsI18nLoading();

  if (isLoading) {
    return <SplashScreen className="bg-surface-1" />;
  }

  return <>{children}</>;
};
